import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-163c2e9a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"min-width":"135px"} }, "Need to add search val", -1))
const _hoisted_2 = {
  key: 0,
  class: "gordita-400-12 brand_almost_black"
}

import { ref } from 'vue';
import COLORS from '@/design-system/colors.json';


export default /*#__PURE__*/_defineComponent({
  __name: 'manageSearch',
  props: {
    modelValue: null
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }: { emit: ({ (e: 'update:modelValue', value: string): void }), expose: any, slots: any, attrs: any }) {



const expandSearchBar = ref(false);
const isSearchInputEllipsis = ref(false);
const searchInput = ref(null);

const clearSearchInput = () => {
  emit('update:modelValue', '');
};

const checkSearchInputEllipsis = () => {
  const searchInputEl = (searchInput.value as any)?.$el?.getElementsByTagName('input')[0];
  return searchInputEl?.offsetWidth < searchInputEl?.scrollWidth;
};
const hidePlaceholder = ref(false);

const handleSearchBlur = () => {
  expandSearchBar.value = false;
  hidePlaceholder.value = true;
  setTimeout(() => {
    hidePlaceholder.value = false;
  }, 400);
};

return (_ctx: any,_cache: any) => {
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_IncrediTransition = _resolveComponent("IncrediTransition")!

  return (_openBlock(), _createBlock(_component_IncrediTransition, {
    class: "search-nav table-upper-buttons",
    "data-testid": "manage-entities-search-nav",
    style: _normalizeStyle({
      transition: 'max-width 0.2s,background 0.2s',
      maxWidth: !__props.modelValue && !expandSearchBar.value ? '86px' : '280px',
      width: expandSearchBar.value ? '280px' : '218px', //this gets to the figma's length when closed with search input.
      background: __props.modelValue && !expandSearchBar.value ? _unref(COLORS)['Hovers/hover_primary'] : null,
    }),
    onTransitionend: _cache[2] || (_cache[2] = ($event: any) => (isSearchInputEllipsis.value = checkSearchInputEllipsis()))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_input, {
        ref: "search-input",
        placeholder: !hidePlaceholder.value ? _ctx.$t('agents.navBar.searchInput.placeholder') : '',
        "model-value": __props.modelValue,
        "input-style": { color: _unref(COLORS)['Text/Dark'] },
        borderless: "",
        dense: "",
        debounce: "300",
        class: _normalizeClass(["search", { expandSearch: expandSearchBar.value }]),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = (val) => emit('update:modelValue', val)),
        onFocus: _cache[1] || (_cache[1] = ($event: any) => (expandSearchBar.value = true)),
        onBlur: handleSearchBlur
      }, {
        append: _withCtx(() => [
          _withDirectives(_createVNode(_component_q_icon, {
            name: "icon-x-small",
            class: "cursor-pointer search-clear-icon",
            onClick: clearSearchInput
          }, null, 512), [
            [_vShow, expandSearchBar.value]
          ])
        ]),
        prepend: _withCtx(() => [
          _createVNode(_component_q_icon, { class: "uil uil-search search-icon" }),
          (!__props.modelValue && !expandSearchBar.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, " Search "))
            : _createCommentVNode("", true)
        ]),
        default: _withCtx(() => [
          (!expandSearchBar.value && isSearchInputEllipsis.value)
            ? (_openBlock(), _createBlock(_component_q_tooltip, {
                key: 0,
                offset: [0, 18],
                anchor: "bottom right",
                self: "center right",
                "content-class": "tooltip-background"
              }, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["placeholder", "model-value", "input-style", "class"])
    ]),
    _: 1
  }, 8, ["style"]))
}
}

})